import { AbstractLoginSuccess } from './login-success-service';
import { goToModuleForRegister } from 'library-components/utils/goToModule';
export const RegisterLoginSuccessService = Symbol('RegisterLoginSuccessService');
export class RegisterLoginSuccessServiceImpl extends AbstractLoginSuccess {
    goToModule(opts) {
        return goToModuleForRegister(opts);
    }
}
